import { createContext } from "react";

export interface SearchFilters {
	field: string;
	search: string[];
}

export interface HideProcess {
	isModelOpen?: boolean;
	selectedProcesses?: string[];
}

export interface FinanceReport {
	isModelOpen?: boolean;
	selectedFiles?: string[];
}

export interface FileSearch {
	isModelOpen?: boolean;
	assignees: string[];
	clients: string[];
	agents: string[];
	creators: string[];
	orderStatuses: string[];
	paymentStatuses: string[];
	files: string[];
	invoices: string[];
}

export interface FileSettingsState {
	hideProcess?: HideProcess;
	financeReport?: FinanceReport;
	fileSearch?: FileSearch;
	fileHistorySearch?: FileSearch;
}

export const initialState: FileSettingsState = {
	hideProcess: {
		isModelOpen: false,
		selectedProcesses: [],
	},
	financeReport: {
		isModelOpen: false,
		selectedFiles: [],
	},
	fileSearch: {
		isModelOpen: false,
		assignees: [],
		clients: [],
		agents: [],
		creators: [],
		orderStatuses: [],
		paymentStatuses: [],
		files: [""],
		invoices: [""],
	},
	fileHistorySearch: {
		isModelOpen: false,
		assignees: [],
		clients: [],
		agents: [],
		creators: [],
		orderStatuses: [],
		paymentStatuses: [],
		files: [""],
		invoices: [""],
	},
};

export interface FileSettingsContext extends FileSettingsState {
	handleHideProcessModelOpen: () => void;
	handleHideProcessModelClose: () => void;
	handleHideProcess: (processId: string) => void;
	handleUnhideProcess: (processId: string) => void;
	handleFileSearchOpen: () => void;
	handleFileSearchClose: () => void;
	handleUpdateSearch: (added: SearchFilters) => void;
	handleClearSearch: () => void;
	handleFileHistorySearchOpen: () => void;
	handleFileHistorySearchClose: () => void;
	handleUpdateFileHistorySearch: (added: SearchFilters) => void;
	handleClearFileHistorySearch: () => void;
}

export const FileSettingsContext = createContext<FileSettingsContext>({
	...initialState,
	handleHideProcessModelOpen: function (): void {
		throw new Error("Function not implemented.");
	},
	handleHideProcessModelClose: function (): void {
		throw new Error("Function not implemented.");
	},
	handleHideProcess: function (_processId: string): void {
		throw new Error("Function not implemented.");
	},
	handleUnhideProcess: function (_processId: string): void {
		throw new Error("Function not implemented.");
	},
	handleFileSearchOpen: function (): void {
		throw new Error("Function not implemented.");
	},
	handleFileSearchClose: function (): void {
		throw new Error("Function not implemented.");
	},
	handleUpdateSearch: function (_added: SearchFilters): void {
		throw new Error("Function not implemented.");
	},
	handleClearSearch: function (): void {
		throw new Error("Function not implemented.");
	},
	handleFileHistorySearchOpen: function (): void {
		throw new Error("Function not implemented.");
	},
	handleFileHistorySearchClose: function (): void {
		throw new Error("Function not implemented.");
	},
	handleUpdateFileHistorySearch: function (_added: SearchFilters): void {
		throw new Error("Function not implemented.");
	},
	handleClearFileHistorySearch: function (): void {
		throw new Error("Function not implemented.");
	},
});
